import styled, { css } from 'styled-components'
import { media } from '@/theme/tokens'

export const BentoGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(12, 1fr);
	gap: 22px;
	align-items: stretch;

	${media.bentoCollapse} {
		gap: 16px;
	}
`

/**
 * The phone-rail recipe shared by the itinerary preview and the files
 * thumbnails: a horizontally scrolling flex row that bleeds through the 20px
 * card padding to the tile edges, scrollbar hidden, horizontal overscroll
 * contained so a rail fling never turns into a page pan. Swipes here scroll
 * without activating the tile (see `usePressWithoutDrag` in `BentoTile`).
 *
 * Interpolate inside the phone media query at each use site. The bottom
 * padding is the only per-tile delta — the handoff specs 8px under the
 * itinerary rail (`.m-rail`) and 6px under the files rail (`.m-files-rail`) —
 * so it is a parameter rather than a hard-coded value.
 */
export const horizontalRailMobile = (bottomPadPx: number) => css`
	display: flex;
	gap: 12px;
	overflow-x: auto;
	margin: 0 -20px;
	padding: 2px 20px ${bottomPadPx}px;
	scrollbar-width: none;
	-webkit-overflow-scrolling: touch;
	overscroll-behavior-x: contain;

	&::-webkit-scrollbar {
		display: none;
	}
`
